import React, { useState } from "react";
import { Icon, Button } from "semantic-ui-react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../../../hooks";
import "./MobileMenu.scss";

// --- Constantes de navegación ---
const navItems = [
  {
    name: "Inicio",
    icon: "home",
    to: "/student/dashboard",
    path: "/student/dashboard",
  },
  {
    name: "Mis cursos",
    icon: "book",
    to: "/student/myCourses",
    path: ["/student/myCourses", /^\/student\/myCourses\/\d+\/$/],
  },
  {
    name: "Foro académico",
    icon: "users",
    to: "/student/forum",
    path: ["/student/forum", /^\/student\/post\/\d+\/$/],
  },
  {
    name: "Clases en vivo",
    icon: "video",
    to: "/student/liveClasses",
    path: "/student/liveClasses",
  },
  {
    name: "Mis pagos",
    icon: "money bill alternate outline",
    to: "/student/myPayments",
    path: "/student/myPayments",
  },
  {
    name: "Mis calificaciones",
    icon: "clipboard list",
    to: "/student/myGrades",
    path: "/student/myGrades",
  },
  {
    name: "Mis notificaciones",
    icon: "history",
    to: "/student/myNotifications",
    path: "/student/myNotifications",
  },
  {
    name: "Documentos institucionales",
    icon: "file pdf outline",
    to: "/student/institutional-documents",
    path: "/student/institutional-documents",
  },
  {
    name: "Chat AI",
    icon: "chat",
    to: "/student/aiChat",
    path: "/student/aiChat",
  },
  {
    name: "Mi perfil",
    icon: "user circle",
    to: "/student/myProfile",
    path: "/student/myProfile",
  },
];

export function MobileMenu(props) {
  const { darkLightTheme } = props;
  const [isOpen, setIsOpen] = useState(false);
  const { pathname } = useLocation();
  const { logout } = useAuth();

  const isCurrentPath = (path) => {
    if (pathname === "/student") return false;
    if (path === pathname) return true;
    if (Array.isArray(path)) {
      return path.some((p) =>
        typeof p === "string" ? pathname.includes(p) : p.test(pathname)
      );
    } else {
      return typeof path === "string"
        ? pathname.includes(path)
        : path.test(pathname);
    }
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const onLogout = async () => {
    closeMenu();
    await logout();
  };

  return (
    <div className={`mobile-menu-container ${isOpen ? "menu-open" : ""}`}>
      {/* Hamburger Button */}
      <Button
        className="mobile-menu__toggle"
        icon={isOpen ? "close" : "bars"}
        onClick={toggleMenu}
      />

      {/* Overlay */}
      {isOpen && <div className="mobile-menu__overlay" onClick={closeMenu} />}

      {/* Mobile Menu Dropdown */}
      <div
        className={`mobile-menu ${isOpen ? "mobile-menu--open" : ""} ${
          darkLightTheme ? "dark" : "light"
        }`}
        // No inline maxHeight ni display, solo el estilo base
      >
        <nav className="mobile-menu__nav">
          {navItems.map((item) => (
            <Link
              key={item.name}
              to={item.to}
              className={`mobile-menu__nav-item ${
                isCurrentPath(item.path) ? "active" : ""
              }`}
              onClick={closeMenu}
            >
              <Icon name={item.icon} />
              <span>{item.name}</span>
            </Link>
          ))}
          <a
            className="mobile-menu__nav-item mobile-menu__nav-item--logout"
            onClick={onLogout}
          >
            <Icon name="sign-out" />
            <span>Cerrar sesión</span>
          </a>
        </nav>
      </div>
    </div>
  );
}
